export default "__VITE_ASSET__B9AagdG5__"